import React from 'react';
import { 
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { NoOpsSelected } from '../components';
import { useOps } from '../hooks/useOps';

export function Home() {
  const { currentOps } = useOps();

  if (!currentOps) {
    return (
      <NoOpsSelected
        message="Selecione uma operação para acessar o sistema."
        fullPage
      />
    );
  }

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold">FAQ - Perguntas Frequentes</h1>
        <p className="text-muted-foreground">
          Encontre respostas para as principais dúvidas sobre o sistema
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Dúvidas Frequentes</CardTitle>
        </CardHeader>
        <CardContent>
          <Accordion type="single" collapsible className="w-full">
            <AccordionItem value="item-1">
              <AccordionTrigger>Como funciona o processo de Checkout?</AccordionTrigger>
              <AccordionContent>
                O Checkout é o processo de confirmação e fechamento das operações financeiras para um determinado período. Primeiro, é necessário realizar o upload das informações referentes às transações (romaneios, pedidos, etc). Em seguida, o usuário poderá realizar o Checkout do dia específico, verificando todos os dados. Após confirmação, a equipe de gestão dará prosseguimento ao processamento dos pagamentos.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-2">
              <AccordionTrigger>O que devo fazer caso o upload resulte em falha?</AccordionTrigger>
              <AccordionContent>
                Neste caso, entre em contato com a equipe de gestão. Provavelmente, os dados estão fora do formato combinado, ou houve alguma regra de negócio não especificada. A equipe analisará o problema e decidirá em conjunto a melhor solução.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-3">
              <AccordionTrigger>Para que serve a página de Status de Pagamento?</AccordionTrigger>
              <AccordionContent>
                A página de Status de Pagamento permite verificar todas as transações que foram liquidadas (pagas) e as que ainda estão pendentes. Você pode filtrar por período específico e visualizar valores totais, quantidades de transações, além de poder baixar relatórios das operações.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-4">
              <AccordionTrigger>Como posso verificar informações sobre uma pessoa específica no sistema?</AccordionTrigger>
              <AccordionContent>
                Utilize a funcionalidade 'Checagem Pessoas' no menu lateral. Nessa página, você poderá inserir o documento (CPF/CNPJ) da pessoa e obter informações como status de cadastro e outras informações relevantes associadas a esse usuário.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-5">
              <AccordionTrigger>O que são as Solicitações de Antecipação?</AccordionTrigger>
              <AccordionContent>
                As Solicitações de Antecipação permitem visualizar os pedidos de adiantamento de pagamento feitos pelos prestadores de serviço. Na página de Antecipação, você consegue ver o valor face (valor total), valor de compra (valor com desconto da taxa de antecipação), datas de vencimento e outras informações relevantes para cada solicitação.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-6">
              <AccordionTrigger>Como funcionam as estatísticas disponíveis no sistema?</AccordionTrigger>
              <AccordionContent>
                A seção de Estatísticas apresenta dados agregados das operações, como número de entregas, valores processados, médias, tendências e outros indicadores importantes para o acompanhamento do negócio. Você pode filtrar por diferentes períodos para análise histórica ou recente.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-7">
              <AccordionTrigger>O que é a Lista de Entregadores/Prestadores?</AccordionTrigger>
              <AccordionContent>
                A Lista de Entregadores/Prestadores exibe todos os prestadores de serviço cadastrados no sistema, com suas informações principais. Esta página permite buscar, filtrar e visualizar os detalhes de cada pessoa cadastrada, facilitando a gestão das operações.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-8">
              <AccordionTrigger>Como realizar o upload de documentos no sistema?</AccordionTrigger>
              <AccordionContent>
                Cada tipo de documento (romaneio, cadastro, financeiro) tem sua própria página de upload. Acesse a página correspondente pelo menu lateral, selecione o arquivo no formato correto (geralmente Excel ou CSV) e confirme o envio. O sistema processará os dados e exibirá mensagens de sucesso ou erro caso necessário.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-9">
              <AccordionTrigger>Qual é a diferença entre valor de face e valor de compra?</AccordionTrigger>
              <AccordionContent>
                O valor de face representa o valor total da operação antes de quaisquer descontos ou taxas. O valor de compra é o valor efetivamente pago após aplicação de taxas, descontos ou tarifas de antecipação, quando aplicáveis.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </CardContent>
      </Card>
    </div>
  );
}